<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        :disabled="dialog || types.length === 0"
        v-on="on"
      >
        <v-icon left>
          add
        </v-icon>
        Create Company
      </v-btn>
    </template>
    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onSubmitForm"
      >
        <v-card-text>
          <v-container grid-list-md>
            <v-layout
              row
              wrap
            >
              <v-flex
                lg6
                px-2
              >
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  label="Name"
                  placeholder="Enter company name"
                />
              </v-flex>
              <v-flex
                lg6
                px-2
              >
                <v-text-field
                  v-model="address"
                  label="Address"
                  placeholder="Enter company address"
                />
              </v-flex>
              <v-flex
                lg6
                px-2
              >
                <v-select
                  v-model="location"
                  :items="locationList"
                  label="Location"
                  placeholder="Pick a location"
                />
              </v-flex>
              <v-flex
                lg6
                px-2
              >
                <v-text-field
                  v-model="email"
                  label="Email"
                  placeholder="Enter company email"
                  type="email"
                />
              </v-flex>
              <v-flex
                lg6
                px-2
              >
                <v-text-field
                  v-model="phone"
                  label="Phone"
                  placeholder="Enter company phone"
                  mask="phone"
                />
              </v-flex>
              <v-flex
                lg6
                px-2
              >
                <v-autocomplete
                  v-model="type"
                  :items="types"
                  label="Type"
                  hide-selected
                  item-text="title"
                  return-object
                  placeholder="Select a company type"
                  :clearable="true"
                />
              </v-flex>
              <v-flex xs12>
                <v-img
                  :src="logo ? logo.object_url : noImage"
                  :lazy-src="logo ? logo.object_url : noImage"
                  aspect-ratio="2.5"
                />
              </v-flex>
              <v-flex>
                <logo-dialog @logo="logo = $event" />
                <v-btn
                  flat
                  :loading="isUploading"
                  @click="$refs.file_handler.click()"
                >
                  <v-icon left>
                    cloud_upload
                  </v-icon>
                  Upload
                </v-btn>
                <input
                  v-show="false"
                  ref="file_handler"
                  type="file"
                  accept="image/*"
                  @change="onFileChanged"
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            flat
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="isSubmitting"
            color="success"
            flat
            type="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LogoDialog from './LogoDialog'
const noImage = require('@/assets/no_image_found.png')
export default {
  components: {
    LogoDialog
  },
  data: () => ({
    dialog: false,
    valid: false,
    isSubmitting: false,
    isUploading: false,
    noImage: noImage,
    locationList: [
      'Abu Dhabi',
      'Ajman',
      'Dubai',
      'Fujairah',
      'Ras Al Khaimah',
      'Sharjah',
      'Um Al Quwain'
    ],
    name: '',
    nameRules: [
      value => !!value || 'Required',
      value => (value && value.length <= 70) || 'Maximum 70 characters',
      value => (value && value.length >= 4) || 'Minimum 4 characters',
    ],
    address: '',
    location: '',
    email: '',
    phone: '',
    logo: null,
    type: null
  }),
  computed: {
    ...mapGetters({
      types: 'clientTypes/types',
      logoItems: 'clientLogo/logo'
    })
  },
  methods: {
    ...mapActions({
      onCreateCompany: 'clientCompanies/createCompany',
      getCompanies: 'clientCompanies/getCompanies',
      setDisplay: 'snackbar/setDisplay',
      setMessage: 'snackbar/setMessage',
      uploadImage: 'clientLogo/uploadImage'
    }),
    onSubmitForm () {
      if (this.$refs.form.validate()) {
        this.isSubmitting = true
        this.onCreateCompany({
          name: this.name,
          address: this.address,
          location: this.location,
          email: this.email,
          phone: this.phone,
          logo_id: this.logo ? this.logo.id : null,
          type_id: this.type ? this.type.id : null
        }).then((response) => {
          if (response.status === 201) {
            this.getCompanies(1, 10).then(() => {
              this.dialog = false
              this.name = ''
              this.address = ''
              this.location = ''
              this.email = ''
              this.phone = ''
              this.logo_id = null
              this.type_id = null
              this.$refs.form.reset()
              this.setDisplay(true)
              this.setMessage('Company was created')
            })
            this.isSubmitting = false
          }
        }).catch(() => {
          this.isSubmitting = false
        })
      }
    },
    onFileChanged (event) {
      this.isUploading = true
      const file = event.target.files[0]
      const formData = new FormData()
      formData.append('image', file)
      this.uploadImage(formData)
      .then((response) => {
        if (response.status === 201) {
          this.logo = response.data.data
          this.isUploading = false
        }
      })
    }
  }
}
</script>
